import { render } from "./productPackage.vue?vue&type=template&id=175ce408&scoped=true"
import script from "./productPackage.vue?vue&type=script&lang=js"
export * from "./productPackage.vue?vue&type=script&lang=js"

import "./productPackage.vue?vue&type=style&index=0&id=175ce408&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175ce408"],['__file',"resources/js/vueComponents/admin/productPackage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "175ce408"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('175ce408', __exports__)) {
    api.reload('175ce408', __exports__)
  }
  
  module.hot.accept("./productPackage.vue?vue&type=template&id=175ce408&scoped=true", () => {
    api.rerender('175ce408', render)
  })

}


export default __exports__